import api from 'api';

export const loadAffiliates = api('GET /api/audiences/fields/affiliates');
export const loadNetworks = api('GET /api/audiences/fields/networks');
export const loadPlatforms = api('GET /api/audiences/fields/platforms');
export const loadApplications = api('GET /api/audiences/fields/applications');
export const loadExcludeApplications = api(
  'GET /api/audiences/fields/exclude-applications'
);
export const loadTrafficTypes = api('GET /api/audiences/fields/traffic-types');
export const loadCountries = api('GET /api/audiences/fields/countries');
export const loadEngagements = api('GET /api/audiences/fields/engagements');
export const loadHashTypes = api('GET /api/audiences/fields/hash-types');
export const loadDataTypes = api('GET /api/audiences/fields/data-types');
export const loadCases = api('GET /api/audiences/fields/cases');
export const loadDevices = api('GET /api/audiences/fields/devices');
export const loadOSversions = api('GET /api/audiences/fields/os-versions');
export const loadOwners = api('GET /api/audiences/fields/owners');
